import { api } from "src/boot/api";

export const index = async (options = {}) => {
  const response = await api.get("/account/paymentsmade", options);

  return response;
};
